import React, { useState } from "react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import "./Styles.css";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMessage, setErrorMessage] = useState("");
  const [sectionRef, sectionVisible] = useScrollAnimation({ threshold: 0.2 });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !/\S+@\S+\.\S+/.test(email)) { 
      setErrorMessage("Please enter a valid email address.");
      setStatus("error"); 
      return; 
    }
    
    try {
      setStatus("loading");
      const API_URL = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || 'https://ceindiazone2.in');
      const response = await fetch(`${API_URL}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setStatus("success");
        setEmail("");
      } else {
        try {
            const data = await response.json();
            setErrorMessage(data.message || "Failed to subscribe due to a server error.");
        } catch {
            setErrorMessage("Failed to subscribe due to a server error.");
        }
        setStatus("error");
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setErrorMessage("Failed to connect to the server.");
      setStatus("error");
    }
  };

  return (
    <section className="nl-section">
      <div className="nl-blob nl-blob--l" aria-hidden="true" />
      <div className="nl-blob nl-blob--r" aria-hidden="true" />

      <div className="container">
        {/* HEADER — eyebrow LEFT, title RIGHT */}
        <div className="section-header">
          <div className="sh-label">
            <span className="eyebrow">Stay Connected</span>
          </div>
          <div className="sh-title">
            <h2 className="section-title">GET UPDATES FROM CHRIST EMBASSY PUNE</h2>
          </div>
        </div>

        <div
          ref={sectionRef}
          className={`nl-inner fade-in-up ${sectionVisible ? 'visible' : ''}`}
        >
          <p className="section-body nl-desc">
            Be the first to hear about upcoming services, events, and messages of faith
            that will inspire your week.
          </p>

          {status === "success" ? (
            <div className="nl-success">
              <div className="nl-check">✓</div>
              <p>You're subscribed! God bless you.</p>
            </div>
          ) : (
            <form className="nl-form" onSubmit={handleSubmit} noValidate>
              <div className={`nl-row ${status === 'error' ? 'nl-row--err' : ''}`}>
                <input
                  type="email"
                  className="nl-input"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setStatus("idle"); }}
                  required
                />
                <button type="submit" className="nl-btn" disabled={status === "loading"}>
                  {status === "loading" ? <span className="nl-spin" /> : "Subscribe"}
                </button>
              </div>
              {status === "error" && <p className="nl-err">{errorMessage}</p>}
              <p className="nl-fine">No spam, ever. Unsubscribe at any time.</p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
